import Box from '@material-ui/core/Box';
import React from 'react';
import { renderDynamicComponent } from '../render';
var DynamicBox = function (_a) {
    var control = _a.control, dataState = _a.dataState;
    return React.createElement(Box, { style: control.styles }, control.children
        .map(function (child, index) { return renderDynamicComponent(index, child, dataState); }));
};
export default DynamicBox;
//# sourceMappingURL=Box.js.map